module.exports = __webpack_public_path__ + "img/st-47c.6877880c.jpg";